import React from 'react';
import { ButtonContained, ButtonOutlined, ButtonText } from '@ntuctech/devex-tangram/Button';
import { Grid, Typography } from '@ntuctech/devex-tangram';
import styled from 'styled-components';
import { numberFormat } from '../../../lib/utils';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';

const MobileView = styled.div`
  display: none;
  img {
    width: 100%;
    border-radius: 8px 8px 8px 8px;
  }

  @media screen and (max-width: 767px) {
    display: block;
  }
  @media screen and (max-width: 600px) {
    position: ${(props) => (props.isKeyboardOpen ? 'none' : '')};
    bottom: 0;
    width: calc(100% - 32px);
    z-index: 99;
    > div {
      margin-bottom: 0;
    }
  }
  @media screen and (max-width: 599px) {
    width: 100%;
  }
`;

const RightWhiteBoxMob = styled.div`
  background-color: #fff;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-bottom: 5px;
  box-shadow: 0px -2px 4px rgba(51, 51, 51, 0.24);
  @media screen and (min-width: 600px) {
    border: 1px solid #eaeaea;
  }
  .previewContainer {
    display: flex;
    align-items: center;
  }
  .width-auto {
    width: auto;
    margin-right: 12px;
  }
  .content-grid {
    flex: 1;
  }
  .fixWidthClass {
    width: 64px;
    height: 40px;
    border: 1px;
    border-radius: 4px;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    padding: 1rem;
    margin-bottom: 0;
  }
  .button-float-right {
    float: right;
    padding: 0;
    margin: 0;
    top: 1rem;
  }
`;

const BoxTitle = styled.h5`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #333333;
  margin: 0;
`;

const RmvMarginBtm = styled.span`
  > button {
    margin-bottom: 0 !important;
  }
`;

const RenderBodyPreview = ({ isEdit, isB2bEnabled, voucherData, openModal }) => {
  const TotalQty = voucherData?.receivers?.map((item) => item.count).reduce((a, b) => a + b, 0);
  const TotalValue = parseInt(
    parseInt(voucherData?.amount / voucherData.quantity, 10) *
      (TotalQty || voucherData?.receivers?.length),
    10
  );

  if (isEdit && !isB2bEnabled) {
    return (
      <Grid className="no-spacing">
        <Typography variant="priceS">Total: {numberFormat(TotalValue.toFixed(2))} </Typography>
        <ButtonText
          className="no-spacing button-float-right"
          data-testid="previewButton"
          onClick={openModal}
        >
          Preview
        </ButtonText>
        <Grid className="no-spacing">
          <Typography variant="caption1Regular">
            Voucher amount:{' '}
            {numberFormat(
              parseInt(Number(voucherData?.amount) / Number(voucherData.quantity), 10).toFixed(2)
            )}
          </Typography>
        </Grid>
        <Grid className="no-spacing">
          <Typography variant="caption1Regular">
            Total quantity: {TotalQty || voucherData?.receivers?.length}
          </Typography>
        </Grid>
      </Grid>
    );
  }
  if (isB2bEnabled) {
    const amount = voucherData.bussinessData?.reduce((acc, key) => {
      return acc + (key.value || key.amount) * key.qty;
    }, 0);
    const totalQty = voucherData.bussinessData?.reduce((acc, key) => {
      return acc + key.qty;
    }, 0);
    const totalVoucherWithQty = voucherData?.bussinessData?.filter((v) => v.qty > 0) || [];
    const totalVoucherAmount = totalVoucherWithQty
      .map((voucher) => `$${voucher.amount || voucher.value}`)
      .join(', ');

    return (
      <>
        <Typography variant="price3">
          Total: {numberFormat((amount || 0)?.toFixed(2))}{' '}
          <ButtonText
            className="no-spacing button-float-right"
            data-testid="previewButton"
            onClick={openModal}
          >
            Preview
          </ButtonText>
        </Typography>
        <Grid className="no-spacing">
          <Typography variant="caption1Regular">Voucher amount: {totalVoucherAmount}</Typography>
        </Grid>
        <Grid className="no-spacing">
          <Typography variant="caption1Regular">Total quantity: {totalQty}</Typography>
        </Grid>
      </>
    );
  }
  return (
    <>
      <BoxTitle>
        Total:
        {numberFormat(
          Number(
            voucherData.amount
              ? voucherData.amount * (TotalQty || voucherData?.receivers?.length)
              : 0
          ).toFixed(2)
        )}
        <ButtonText
          className="no-spacing button-float-right"
          data-testid="previewButton"
          onClick={openModal}
        >
          Preview
        </ButtonText>
      </BoxTitle>
      <Grid className="no-spacing">
        <Typography variant="caption1Regular">
          Voucher amount:{' '}
          {numberFormat(Number(voucherData.amount ? voucherData.amount : 0).toFixed(2))}
        </Typography>
      </Grid>
      <Grid className="no-spacing">
        <Typography variant="caption1Regular">
          Total quantity: {TotalQty || voucherData?.receivers?.length}
        </Typography>
      </Grid>
    </>
  );
};

export const MobileModel = (props) => {
  const {
    voucherData,
    isEditMode,
    cancelButon,
    saveButton,
    addToCart,
    openModal,
    isEnabled,
    isEnabledSaveBtn,
    isKeyboardOpen,
    isB2bEnabled,
    addToCartBusiness,
  } = props;
  /* eslint-disable radix */
  return (
    <MobileView isKeyboardOpen={isKeyboardOpen}>
      <RightWhiteBoxMob>
        <Grid container className="no-spacing">
          <Grid item xs={12}>
            <Grid className="previewContainer no-spacing">
              <Grid className="no-spacing width-auto">
                <img className="fixWidthClass" alt="" src={voucherData.metadata.image} />
              </Grid>
              <Grid className="content-grid no-spacing">
                <RenderBodyPreview
                  isEdit={isEditMode}
                  isB2bEnabled={isB2bEnabled}
                  voucherData={voucherData}
                  openModal={openModal}
                />
              </Grid>
            </Grid>
          </Grid>

          {isEditMode === true ? (
            <>
              <Grid item xs={6}>
                <ButtonOutlined
                  size="m"
                  fullWidth
                  data-testid="cancel-button1"
                  onClick={() => cancelButon()}
                >
                  Cancel
                </ButtonOutlined>
              </Grid>
              <Grid item xs={6}>
                <ButtonContained
                  size="m"
                  disabled={!isEnabledSaveBtn}
                  fullWidth
                  data-testid="save-button1"
                  onClick={(e) => {
                    if (isB2bEnabled) {
                      addToCartBusiness(e);
                    } else {
                      saveButton();
                    }
                  }}
                >
                  Save
                </ButtonContained>
              </Grid>
            </>
          ) : (
            <Grid item xs={12}>
              <RmvMarginBtm>
                <ButtonContained
                  size="m"
                  disabled={!isEnabled}
                  fullWidth
                  data-testid="Add-cart-button1"
                  onClick={(e) => {
                    if (isB2bEnabled) {
                      addToCartBusiness(e);
                    } else {
                      addToCart();
                    }
                  }}
                >
                  Add to cart
                </ButtonContained>
              </RmvMarginBtm>
            </Grid>
          )}
        </Grid>
      </RightWhiteBoxMob>
    </MobileView>
  );
};
export default MobileModel;
